module.exports = __webpack_public_path__ + "static/media/card-active.dfd8f20f.svg";